import React from 'react';
import ConversionMeasurementDatasetPanel from './ConversionMeasurementDatasetPanel';
import kochavaExposuresRaw from './Kochava_exposures (1).csv?raw';

const ConversionMeasurementExposureTab: React.FC = () => (
    <ConversionMeasurementDatasetPanel rawCsv={kochavaExposuresRaw} dataset="exposure" />
);

export default ConversionMeasurementExposureTab;
